import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/marathon-el-salvador-landing/marathon-el-salvador-landing/src/components/buttons/LinkButton.tsx");
